var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 124,
    viewBox: "0 0 131 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_498",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3125,
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.34375 -9.98633H137.629V133.987H-6.34375V-9.98633Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.629 -9.98633V8.01032L84.2019 62.0003L137.629 114.584V133.987H118.789L65.0804 81.1217L12.7777 133.987H-6.34375V114.865L45.959 62.2814L-6.34375 10.8223V-9.98633H11.0905L65.0804 42.8788L117.383 -9.98633H137.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3966 81.1217L48.4898 90.6824L5.46655 133.987H-6.34375V133.143L45.3966 81.1217ZM80.2651 77.7473L95.4498 79.9969L137.629 121.333V133.987L80.2651 77.7473ZM137.629 -9.98633L83.6395 45.1284L82.5147 32.7557L124.694 -9.98633H137.629ZM-6.34375 -9.70513L47.9274 43.4412L31.3367 41.1916L-6.34375 3.79235V-9.70513Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.147 -9.98633V133.987H88.1386V-9.98633H43.147ZM-6.34375 39.5044V84.4961H137.629V39.5044H-6.34375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.34375 48.5028V75.4977H137.629V48.5028H-6.34375ZM52.1453 -9.98633V133.987H79.1403V-9.98633H52.1453Z",
    fill: "#C8102E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry4);
export default __webpack_public_path__ + "static/media/country4.6c4099dca83c2a2a7fc5c794e6a079fb.svg";
export { ForwardRef as ReactComponent };